<template>
  <div class="container">
    <div class="filter-block">
      <el-select class="margin-30" v-model="status" placeholder="请选择">
        <el-option
          v-for="item in statusList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <label style="margin-right: 10px">查询日期</label>
      <el-date-picker
        v-model="time"
        type="daterange"
        align="center"
        value-format="yyyy-MM-dd HH:mm:ss"
        class="margin-30"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-button type="primary" @click="getItemList">筛选</el-button>
    </div>
    <div class="table-container">
      <el-table :data="tableData" stripe border="" style="width: 100%">
        <el-table-column prop="id" label="ID" width="120"></el-table-column>
        <el-table-column prop="user_id" label="用户ID"></el-table-column>
        <el-table-column prop="source" label="来源"></el-table-column>
        <el-table-column prop="status" label="状态"></el-table-column>
        <el-table-column prop="type_name" label="类型" />
        <el-table-column
          prop="category.member_second"
          label="会员时长(天)"
        ></el-table-column>
        <el-table-column prop="time" label="操作时间"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
const TYPE_MAP = {
  r: "会员资格",
  uc: "会员卡"
};

import request from "../../api/request";

export default {
  data() {
    return {
      tableData: [],
      statusList: [
        {
          label: '全部',
          value: -1
        },
        {
          label: "创建",
          value: 0
        },
        {
          label: "尝试使用",
          value: 50
        },
        {
          label: "失败关闭",
          value: 997
        },
        {
          label: "作废",
          value: 998
        },
        {
          label: "完成",
          value: 999
        }
      ],
      status: -1,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      time: []
    };
  },
  created() {
    this.getItemList();
  },
  methods: {
    async getItemList() {
      let params = {
        filter: {
          source: 'a'
        },
        range: [0, 1e6]
      };
      if (this.time[0] && this.time[1]) {
        params.filter.time = this.time
      }
      if (this.status >= 0) {
        params.filter.status = this.status
      }
      const resp = await request.shop.post("item_list", params);
      this.tableData = resp.data.list.map(item => {
        item.status = this.statusList.map(status => {
          if (item.status === status.value) {
            return status.label;
          }
        });

        switch (item.source) {
          case "a":
            item.source = "管理员发放";
            break;
          case "d":
            item.source = "用户订单";
            break;
          default:
            break;
        }
        item.category.member_second = item.category.member_second / (3600 * 24);
        item.type_name = TYPE_MAP[item.type] || "未知";
        return item;
      });
    }
  }
};
</script>

<style scoped>
.filter-block {
  margin-bottom: 20px;
}
.head {
  text-align: right;
  margin-bottom: 30px;
}
.item {
  width: 200px;
}
.margin-30 {
  margin-right: 30px;
}
.table-container {
  height: 400px;
}
</style>
